import { render, staticRenderFns } from "./FormTypeArticle.vue?vue&type=template&id=0790a2de&scoped=true"
import script from "./FormTypeArticle.vue?vue&type=script&lang=js"
export * from "./FormTypeArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0790a2de",
  null
  
)

export default component.exports